<div class="outer-div">
  <div class="label-bar">
    <label
      i18n="@@spmsUserReg"
      class="textColour"
      style="font-size: 18px; font-weight: 500"
      >Signal Configuration</label
    >
    <span class="example-spacer"></span>
    <app-common-button
    *ngIf="activeComponent === 'Source_mapping'"
      icon="fas fa-download"
      title="Download"
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      (clicked)="onDownload()"
      style="margin-right: 1%"
    >
    </app-common-button>
    <app-common-button
    *ngIf="activeComponent === 'Source_mapping'"
      title="Refresh"
      icon="fas fa-sync-alt"
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      (clicked)="onRefresh()"
      style="margin-right: 1%"
    >
    </app-common-button>
    <app-common-button
    *ngIf="activeComponent === 'validation_activity_config'"
      title="Refresh"
      icon="fas fa-sync-alt"
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      (clicked)="onGeneralConfigRefresh()"
      style="margin-right: 1%"
    >
    </app-common-button>
    <app-common-button
    *ngIf="activeComponent === 'Source_mapping'"
      label="Create"
      title="Create"
      icon="fas fa-plus-circle"
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      (clicked)="onCreate()"
      style="margin-right: 1%"
    >
    </app-common-button>
  </div>

  <div class="report-body">
    <div class="actions-tabs">
      <div
        class="tab-item"
        [class.active]="activeComponent === 'Source_mapping'"
        (click)="showSourceMapping()"
      >
        <i class="fas fa-tasks"></i>
        <span>Source Mapping</span>
      </div>

      <div
        class="tab-item"
        [class.active]="activeComponent === 'validation_activity_config'"
        (click)="showGeneralConfig()"
      >
        <i class="fas fa-cog"></i>
        <span>Validation Configuration</span>
      </div>
    </div>
    <!-- Dynamic component display -->
    <div class="content">
      <ng-container *ngIf="activeComponent === 'Source_mapping'">
        <div style="width: 100%; margin-bottom: 5%">
          <ag-grid-angular
            style="margin-top: 2%; height: 55vh"
            class="ag-theme-balham"
            [rowData]="rowData"
            [components]="components"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [rowSelection]="'multiple'"
            [suppressRowClickSelection]="true"
            [animateRows]="true"
            [paginationPageSize]="10"
            (gridReady)="onGridReady($event)"
            [rowHeight]="35"
      [headerHeight]="35"
      [enableBrowserTooltips]="true"
      [floatingFiltersHeight]="45"
            [pagination]="true"
          >
          </ag-grid-angular>
          <!-- <div class="custom-pagination">
            <span class="range-text">
              {{ startRow }} to {{ endRow }} of {{ totalRows }}
            </span> -->

            <!-- <button (click)="goToFirst()" [disabled]="currentPage === 1">
     
  </button> -->
            <!-- <em
              class="fas fa-angle-double-left waves-effect waves-light"
              (click)="goToFirst()"
            ></em>
            <em
              class="fas fa-angle-left waves-effect waves-light"
              (click)="goToPrevious()"
            ></em> -->
            <!-- <button (click)="goToPrevious()" [disabled]="currentPage === 1">‹</button> -->

            <!-- <span class="page-text">
              Page {{ currentPage }} of {{ totalPages }}
            </span>
            <em
              class="fas fa-angle-right waves-effect waves-light"
              (click)="goToNext()"
            ></em>
            <em
              class="fas fa-angle-double-right waves-effect waves-light"
              (click)="goToLast()"
            ></em> -->
            <!-- <button (click)="goToNext()" [disabled]="currentPage === totalPages">›</button>
  <button (click)="goToLast()" [disabled]="currentPage === totalPages">»</button> -->
          <!-- </div> -->
        </div>
      </ng-container>

<ng-container *ngIf="activeComponent === 'validation_activity_config'">

 <div class="config-container" [formGroup]="generalForm">
  <!-- Show validation SLA  card if we have Valid Sla Id (Inserted From Flyway by Default ) -->
  <div class="config-card" *ngIf="validationSlaId">

    <!-- Header -->
    <div class="card-header">
      <span>Validation SLA Days</span>

      <!-- Edit Icon -->
      <em
        *ngIf="!isEditMode"
        class="fas fa-pen edit-icon"
        (click)="enableEdit()"
      ></em>
    </div>

    <!-- Body -->
    <div class="card-body">

      <!-- VIEW MODE -->
      <div *ngIf="!isEditMode" class="view-mode">
        <span class="config-value">
          {{ generalForm.get('slaDays')?.value }} Days
        </span>

        <div class="config-desc">
          Defines validation timeline
        </div>
      </div>

      <!-- EDIT MODE -->
<div *ngIf="isEditMode" class="edit-mode">

  <!-- ROW: input + suffix + icons -->
  <div class="input-row">
    <input
    type="number"
    formControlName="slaDays"
    class="input"
    min="0"
    step="1"
    inputmode="numeric"
    pattern="[0-9]*"
    (keydown)="allowOnlyNumbers($event)"
    [class.error]="generalForm.get('slaDays')?.invalid && generalForm.get('slaDays')?.touched"
  />

    <span class="suffix">Days</span>

    <!-- Save -->
    <em
      class="fas fa-check icon save"
      (click)="saveGeneralConfig()"
    ></em>

    <!-- Cancel -->
    <em
      class="fas fa-times icon cancel"
      (click)="cancelEdit()"
    ></em>
  </div>

  <!-- 🔴 ERROR BELOW INPUT -->
  <div
    class="error-text"
    *ngIf="generalForm.get('slaDays')?.touched && generalForm.get('slaDays')?.invalid"
  >
    <div *ngIf="generalForm.get('slaDays')?.errors?.['required']">
      SLA Days is required
    </div>

    <div *ngIf="generalForm.get('slaDays')?.errors?.['min']">
      Minimum value should be 1
    </div>
    <div *ngIf="generalForm.get('slaDays')?.errors?.['pattern']">
      Only numeric values are allowed
      </div>
        <div *ngIf="generalForm.get('slaDays')?.errors?.['min']">
         Value cannot be negative.
      </div>
      
  </div>

</div>

    </div>

  </div>

</div>

</ng-container>
    </div>
  </div>
</div>
